// Re-export status color maps from theme directory
export {
  ACTIVITY_STATUS_COLORS,
  GOAL_STATUS_COLORS,
} from './theme/index';
